import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { TextField, Button, InputAdornment } from '@mui/material';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { getQueryVariable, checkValidSession, client, getAdminID, getToken, actionGetTransaction } from "../store/action/RemoteActionSupervisor";
import { resetTimout } from "./common/FirebaseSupervisor";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";

let SERVER_API_URL = process.env.REACT_APP_SERVER_URL_API;

const TransactionDetails = (props) => {
    const [txn, setTxn] = useState({});
    const [language, setLanguage] = useState("");
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);
    const navigate = useNavigate();

    const goToPrevPage = async () => {
        resetTimout();
        setIsButtonClicked(true);
        navigate(-2);
    };

    const updateAsSuspiciousTransaction = async () => {
        let sTransactionID = txn.TransactionID;
        if (!sTransactionID) {
            return;
        }
        if (window.confirm(getMultiLanguageMessage('msg_SuspiciousTransaction_Confirm', language))) {
            let requestBody = {
                VfaspID: process.env.REACT_APP_VFASP_CODE,
                AdminID: getAdminID(),
                TransactionID: sTransactionID
            };
            setIsButtonClicked(true);

            if (!checkValidSession()) {
                return;
            }
            await client(getToken()).post(`${SERVER_API_URL}/transaction/update/suspicious`, requestBody).then((response) => {
                if (response.status == 200) {
                    setTxn({});
                    props.actionGetTransaction(sTransactionID);
                    setIsSubmitSuccess(true);
                } else {
                    alert(getMultiLanguageMessage('msg_Server_Error', language));
                    setIsSubmitSuccess(false);
                }
            }).catch(error => {
                alert(getMultiLanguageMessage('msg_Server_Error', language));
            });
            setIsButtonClicked(false);
        }
    };

    const goToShowUserDetails = async () => {
        resetTimout();
        if (!txn.TransactionID) {
            return;
        }
        navigate('/userdetailsinfo?TID=' + txn.TransactionID);
    };

    useEffect(() => {
        if (props?.transaction && props?.transaction.TransactionID) {
            setTxn(props.transaction);
        }
    }, [props.transaction]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        let tid = getQueryVariable(window.location.search, "TID");
        if (tid && tid.length > 0) {
            props.actionGetTransaction(tid);
        } else {
            alert('Invalid Selection');
        }
    }, []);

    return ((txn && txn.TransactionID) ?
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-TransactionDetails')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">

                        <table width='100%'>
                            <tbody>
                                <tr>
                                    <td className='td-type2-col1'>{translate('TransactionID')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_TransactionID" name="id_TransactionID" sx={{ width: '50ch' }} value={txn.TransactionID} disabled={true} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('TransactionStatus')}</td>
                                    <td className='td-type2-col2'>
                                        {
                                            (txn.ProcessStatus === "PROCESSED") ? translate('Txn-Completed') :
                                                (txn.TxnStatus === "CANCELLED") ? translate('Txn-Cancelled') :
                                                    (txn.TxnStatus === "DECLINED") ? translate('Txn-Declined') :
                                                        (txn.ProcessStatus === "IN-PROGRESS") ? translate('Txn-Progress') :
                                                            (txn.TxnStatus === "EXPIRED") ? translate('Txn-Expired') :
                                                                (txn.TxnStatus === "ERROR") ? translate('Txn-Error') : translate('Txn-Pending')
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('UserID')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_UserID" name="id_UserID" sx={{ width: '50ch' }} value={txn.UserID} disabled={true} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('DateTime')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_DateCreated" name="id_DateCreated" sx={{ width: '25ch' }} value={txn.DateCreated} disabled={true} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('BuySell')}</td>
                                    <td className='td-type2-col2'>
                                        <div className={(txn.BuySellFlag === 2 || txn.BuySellFlag === 3 || txn.BuySellFlag === 8 || txn.BuySellFlag === 9) ? 'Message-Red' : 'Message-Blue'}>{txn.BuySellFlag === 5 ? translate('Transaction-Bonus') : (txn.BuySellFlag === 4 || txn.BuySellFlag === 3) ? translate('Transaction-Gift') : (txn.BuySellFlag === 2 || txn.BuySellFlag === 8 || txn.BuySellFlag === 9) ? translate('Transaction-Sell') : translate('Transaction-Buy')}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Tokens')}</td>
                                    <td className='td-type2-col2'>
                                        {((txn.BuySellFlag === 2 || txn.BuySellFlag === 7) && txn.OtcFlag === 1 && (txn.UsedQuantity > 0 || txn.PendingQuantity > 0) && (txn.UsedQuantity < txn.Quantity)) ?
                                            <div>
                                                <span>{txn.BuySellFlag === 2 ? '-' : ''}{txn.UsedQuantity + txn.PendingQuantity}</span>
                                                <span>({txn.UsedQuantity + txn.PendingQuantity}/{txn.Quantity})</span>
                                            </div>
                                            :
                                            <span>{(txn.BuySellFlag === 2 || txn.BuySellFlag === 3 || txn.BuySellFlag === 8 || txn.BuySellFlag === 9) ? '-' : '+'}{txn.Quantity}</span>
                                        }
                                        {' '}{txn.CryptoAsset}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('UnitPrice')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_UnitPrice" name="id_UnitPrice" sx={{ width: '25ch' }} value={txn.UnitPrice} disabled={true}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">{translate('Euro')}</InputAdornment>,
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Amount')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_Amount" name="id_Amount" sx={{ width: '25ch' }} value={txn.Amount} disabled={true}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">{translate('Euro')}</InputAdornment>,
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('EstimatedGasFee')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_EstimatedGasFee" name="id_EstimatedGasFee" sx={{ width: '25ch' }} value={txn.EstimatedOtherGasFees} disabled={true} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('GasFee')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_GasFee" name="id_GasFee" sx={{ width: '25ch' }} value={txn.OtherGasFees} disabled={true} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Commission')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_Commission" name="id_Commission" sx={{ width: '25ch' }} value={txn.CommissionAmount} disabled={true}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">{translate('Euro')}</InputAdornment>,
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('FromWalletID')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_FromWalletID" name="id_FromWalletID" sx={{ width: '50ch' }} value={txn.FromWalletID} disabled={true} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('ToWalletID')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_ToWalletID" name="id_ToWalletID" sx={{ width: '50ch' }} value={txn.ToWalletID} disabled={true} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('TrancheID')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_TrancheID" name="id_TrancheID" sx={{ width: '25ch' }} value={txn.TrancheID} disabled={true} />
                                    </td>
                                </tr>
                                {(txn.ProcessStatus === 'PROCESSED') ?
                                    <tr>
                                        <td className='td-type2-col1'>{translate('BlockchainTransactionID')}</td>
                                        <td className='td-type2-col2'>
                                            <TextField size="small" id="id_BlockchainTransactionID" name="id_BlockchainTransactionID" sx={{ width: '25ch' }} value={txn.BlockchainTransactionID} disabled={true} />
                                        </td>
                                    </tr>
                                    : null
                                }
                                {(txn.ProcessStatus === 'PROCESSED') ?
                                    <tr>
                                        <td className='td-type2-col1'>{translate('BlockchainRequestKey')}</td>
                                        <td className='td-type2-col2'>
                                            <TextField size="small" id="id_BlockchainRequestKey" name="id_" sx={{ width: '60ch' }} value={txn.BlockchainRequestKey} disabled={true} />
                                        </td>
                                    </tr>
                                    : null
                                }
                                <tr>
                                    <td className='td-type2-col1'>{translate('ModifiedDate')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_LastUpdated" name="id_LastUpdated" sx={{ width: '25ch' }} value={txn.LastUpdated} disabled={true} />
                                    </td>
                                </tr>
                                {(txn.TransactionType > 0) &&
                                    <tr>
                                        <td className='td-type2-col1'>{translate('UserDetails')}</td>
                                        <td className='td-type2-col2'>
                                            {(txn.TransactionType === 1) &&
                                                translate('Status-Requested')
                                            }
                                            {(txn.TransactionType === 2) &&
                                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => goToShowUserDetails()}>{translate('btnViewUserDetails')}</Button>
                                            }
                                            {(txn.TransactionType === 3) &&
                                                translate('Status-Rejected')
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>

                        {isSubmitSuccess &&
                            <>
                                <div className="gaps-2x d-sm-none" />
                                <span className="color-success">
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                </span>
                            </>
                        }

                        <div>
                            <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => goToPrevPage()}>{translate('btnBack')}</Button>
                            {(txn.TransactionType === 0) &&
                                <>
                                    &nbsp;&nbsp;
                                    <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => updateAsSuspiciousTransaction()}>{translate('btnSuspiciousTransaction')}</Button>
                                </>
                            }
                            <div className="gaps-2x" />
                        </div>

                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div>
            {/* .tab-content */}
        </div>
        : "");
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        transaction: state.remote.transaction
    };
};

export default connect(mapStateToProps, {
    actionGetTransaction
})(TransactionDetails);
